import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import RemoveExif from '../../components/RemoveExif';

const RemoveExifPage: React.FC = () => (
  <ToolLayout
    title="Remove EXIF Data from Image - Strip Metadata | AllTools"
    description="Remove EXIF metadata from photos. Strip GPS location, camera info, and other data. Free privacy tool."
    canonicalPath="/remove-exif"
  >
    <RemoveExif />
  </ToolLayout>
);

export default RemoveExifPage;
